module.exports = __webpack_public_path__ + "img/ai-img-office.e2c31e56.png";